import { css } from '@eti/styles';
import { Stack } from '@etg/wings';
import { getSegment } from '../utils/seatMapContentUtils';
import { SEATING_PREFERENCE_OPTIONS } from '../utils/constants';
import SeatingLightOrBeside from './SeatingLightOrBeside';
import UnavailableSegment from './UnavailableSegment';
import { jsx as _jsx } from "react/jsx-runtime";
const seatMapMainContentWrapper = css`
  height: 86%;
`;
const SeatMapMainContent = _ref => {
  let {
    onChange,
    segments,
    activeTraveler,
    activeSegment,
    getSelected
  } = _ref;
  const currentSegment = getSegment(segments, activeSegment);
  const isSeatingPreferenceAvailable = (currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment.__typename) === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_BESIDE || (currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment.__typename) === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_PREFERENCE;
  const {
    __typename,
    price
  } = currentSegment || {};
  return /*#__PURE__*/_jsx(Stack, {
    className: seatMapMainContentWrapper,
    "data-testid": "seatMap-maincontent",
    children: isSeatingPreferenceAvailable ? /*#__PURE__*/_jsx(SeatingLightOrBeside, {
      activeSegment: activeSegment,
      activeTraveler: activeTraveler,
      onChange: onChange,
      price: price,
      selectedSeatPreference: getSelected(activeSegment),
      typename: __typename
    }) : /*#__PURE__*/_jsx(UnavailableSegment, {})
  });
};
export default SeatMapMainContent;
//# sourceMappingURL=SeatMapMainContent.js.map